var map = {
	"./Avatar-0.png": 841,
	"./Avatar-1.png": 842,
	"./Avatar-10.png": 843,
	"./Avatar-11.png": 844,
	"./Avatar-12.png": 845,
	"./Avatar-13.png": 846,
	"./Avatar-14.png": 847,
	"./Avatar-15.png": 848,
	"./Avatar-16.png": 849,
	"./Avatar-17.png": 850,
	"./Avatar-18.png": 851,
	"./Avatar-19.png": 852,
	"./Avatar-2.png": 853,
	"./Avatar-20.png": 854,
	"./Avatar-21.png": 855,
	"./Avatar-22.png": 856,
	"./Avatar-23.png": 857,
	"./Avatar-24.png": 858,
	"./Avatar-25.png": 859,
	"./Avatar-26.png": 860,
	"./Avatar-27.png": 861,
	"./Avatar-28.png": 862,
	"./Avatar-3.png": 863,
	"./Avatar-4.png": 864,
	"./Avatar-5.png": 865,
	"./Avatar-6.png": 866,
	"./Avatar-7.png": 867,
	"./Avatar-8.png": 868,
	"./Avatar-9.png": 869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;